import { render } from "./PmNavbar.vue?vue&type=template&id=dfc72b02&scoped=true"
import script from "./PmNavbar.vue?vue&type=script&lang=js"
export * from "./PmNavbar.vue?vue&type=script&lang=js"

import "./PmNavbar.vue?vue&type=style&index=0&id=dfc72b02&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfc72b02"]])

export default __exports__